import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import BurstModeIcon from "@mui/icons-material/BurstMode";
import DeleteIcon from "@mui/icons-material/Delete";
import { useInventarios } from "../../../context/Inventarios/InventariosContext";
import { useDoubleClickPrevention } from "../../../hooks/useDoubleClickPrevention";

export default function MnuConteosInicializacionConFotoActions({
  onBuscarArticulo,
  onIdentificarIA,
  onToggleBarrido,
  onGuardarFoto,
  onCargarFoto,
  onVolverCamara,
  onGirarCamara,
  onAplicarTemporal,
  onLimpiarTemporal,
  onEntrenarMuestras,
  onEliminarEntrenamiento,
  barridoActivo = false,
  hayCamara = false,
  hayImagen = false,
  hayArticulo = false,
  hayTemporales = false,
  puedeAplicarConteo = false,
  aplicarBloqueado = false,
  hayInventarioActivo = false,
  hayEntrenamiento = false,
  bloqueado = false,
  procesando = false,
}) {
  const { handleClickRegresarMainDashboard } = useInventarios();
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const disabledGeneral = isProcessing || bloqueado || procesando;

  const ejecutar = (event, accion) => {
    event?.currentTarget?.blur?.();
    if (!accion) return;
    executeWithProtection(accion);
  };

  return (
    <Fragment>
      <Tooltip title="Salir">
        <span>
          <IconButton onClick={(event) => ejecutar(event, handleClickRegresarMainDashboard)} disabled={isProcessing}>
            <HomeIcon className="icon" />
            <p className="icon">Salir</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Buscar artículo">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onBuscarArticulo)} disabled={disabledGeneral || !hayInventarioActivo}>
            <SearchIcon className="icon" />
            <p className="icon">Buscar</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Identificar artículo con IA">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onIdentificarIA)} disabled={disabledGeneral || (!hayCamara && !hayImagen)}>
            <PsychologyIcon className="icon" />
            <p className="icon">IA</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={barridoActivo ? "Pausar barrido visual" : "Iniciar barrido visual"}>
        <span>
          <IconButton onClick={(event) => ejecutar(event, onToggleBarrido)} disabled={disabledGeneral || !hayCamara || hayImagen}>
            {barridoActivo ? <PauseIcon className="icon" /> : <PlayArrowIcon className="icon" />}
            <p className="icon">{barridoActivo ? "Pausar" : "Barrido"}</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Guardar foto del artículo">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onGuardarFoto)} disabled={disabledGeneral || !hayArticulo || (!hayCamara && !hayImagen)}>
            <PhotoCameraIcon className="icon" />
            <p className="icon">Foto</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Cargar foto desde archivo">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onCargarFoto)} disabled={disabledGeneral}>
            <UploadFileIcon className="icon" />
            <p className="icon">Cargar</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={hayImagen ? "Volver a cámara" : "Girar cámara"}>
        <span>
          <IconButton onClick={(event) => ejecutar(event, hayImagen ? onVolverCamara : onGirarCamara)} disabled={disabledGeneral || (!hayImagen && !hayCamara)}>
            <CameraswitchIcon className="icon" />
            <p className="icon">Cámara</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Entrenar con 10 fotos">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onEntrenarMuestras)} disabled={disabledGeneral || !hayArticulo || !hayCamara || hayImagen}>
            <BurstModeIcon className="icon" />
            <p className="icon">Entrenar</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Eliminar entrenamiento del artículo">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onEliminarEntrenamiento)} disabled={disabledGeneral || !hayArticulo || !hayEntrenamiento} color="error">
            <DeleteIcon className="icon" />
            <p className="icon">Borrar IA</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Aplicar lista temporal y sumar Conteo 1">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onAplicarTemporal)} disabled={disabledGeneral || aplicarBloqueado || (!hayTemporales && !puedeAplicarConteo) || !hayInventarioActivo}>
            <PlaylistAddCheckIcon className="icon" />
            <p className="icon">Aplicar</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Limpiar lista temporal IA">
        <span>
          <IconButton onClick={(event) => ejecutar(event, onLimpiarTemporal)} disabled={disabledGeneral || (!hayTemporales && !hayArticulo && !hayImagen)}>
            <CleaningServicesIcon className="icon" />
            <p className="icon">Limpiar</p>
          </IconButton>
        </span>
      </Tooltip>
    </Fragment>
  );
}
